/**
 * Connection bubble component
 * Shows on item edges for creating dependency links
 */

import { useState } from 'react';
import type { BubbleType, Point } from './types';
import { DEPENDENCY_CONSTANTS } from './types';

interface ConnectionBubbleProps {
  itemId: number;
  type: BubbleType;
  position: Point;
  onDragStart: (itemId: number, type: BubbleType, position: Point) => void;
  isActive?: boolean;
  isDropTarget?: boolean;
  isValidTarget?: boolean;
}

export function ConnectionBubble({
  itemId,
  type,
  position,
  onDragStart,
  isActive = false,
  isDropTarget = false,
  isValidTarget = true,
}: ConnectionBubbleProps) {
  const [isHovered, setIsHovered] = useState(false);

  const radius = DEPENDENCY_CONSTANTS.BUBBLE_RADIUS;

  // Color based on state
  let fillColor = 'white';
  let strokeColor = 'gray'; // green-500
  const strokeWidth = 1;

  if (isDropTarget) {
    if (isValidTarget) {
      fillColor = '#dcfce7'; // green-100
    } else {
      fillColor = '#ef4444'; // red-500
      strokeColor = '#dc2626'; // red-600
    }
  } else if (isActive || isHovered) {
    fillColor = '#dcfce7'; // green-100
  }

  const handleMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onDragStart(itemId, type, position);
  };

  return (
    <g>
      {/** biome-ignore lint/a11y/noStaticElementInteractions: This is a draggable control for creating dependencies */}
      <circle
        cx={position.x}
        cy={position.y}
        r={radius}
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        className="cursor-crosshair"
        style={{ pointerEvents: 'all' }}
        onMouseDown={handleMouseDown}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <title>{type === 'left' ? 'Predecessor' : 'Successor'} connection point</title>
      </circle>
    </g>
  );
}
